import PropTypes from 'prop-types';
import React from 'react';
import { chairRentalPaymentShape } from '../shapes';
import Date from '../../../../common/date';
import ChairRentalChargeableAmount from '../containers/ChairRentalChargeableAmount';
import ChairRentalAmount from './ChairRentalAmount';

const ChairRentalPayment = ({ chairRentalPayment, barberId, card }) => (
  <div className="c-table-card__row">
    <div className="c-table-card__cell u-2/10">
      <div className="c-chair-rental-data--small u-type--uppercase u-pb--">
        for dates
      </div>
      <div className="c-chair-rental-data--small">
        <Date format="MM/DD">{chairRentalPayment.fromDate}</Date>
        {' '}-{' '}
        <Date format="MM/DD">{chairRentalPayment.toDate}</Date>
      </div>
    </div>
    <div className="c-table-card__cell u-3/10">
      <div className="c-chair-rental-data u-co-gray-2 u-type--uppercase" display-if={chairRentalPayment.markedAsPaid}>
        Mark as paid
      </div>
      <div className="c-chair-rental-data u-co-gray-2 u-type--uppercase" display-if={!chairRentalPayment.markedAsPaid}>
        {card?.brand} {card?.last4}
      </div>
    </div>
    <div className="c-table-card__cell u-3/10">
      <ChairRentalChargeableAmount
        display-if={chairRentalPayment.status === 'overdue'}
        payment={chairRentalPayment}
        barberId={barberId}
      />
      <ChairRentalAmount
        color="green"
        display-if={chairRentalPayment.status !== 'overdue'}
        amount={chairRentalPayment.amount}
        showSuffix
      />
    </div>
    <div className="c-table-card__cell u-2/10">
      <div className="c-chair-rental-data u-co-gray-2">
        <Date format="MM/DD/YYYY">{chairRentalPayment.toDate}</Date>
      </div>
    </div>
  </div>
);

ChairRentalPayment.propTypes = {
  chairRentalPayment: chairRentalPaymentShape.isRequired,
  barberId: PropTypes.string,
  card: PropTypes.shape({
    brand: PropTypes.string,
    last4: PropTypes.string,
  }),
};

ChairRentalPayment.defaultProps = {
  barberId: '',
  card: null,
};

export default ChairRentalPayment;
